<script lang="ts">
  import { onMount, onDestroy } from 'svelte';
  import L from 'leaflet';

  // We still import it here to ensure Vite includes it in the bundle for this component
  import 'leaflet/dist/leaflet.css';

  // Fix for default marker icons using static assets in public/images/leaflet/
  delete (L.Icon.Default.prototype as any)._getIconUrl;

  L.Icon.Default.mergeOptions({
    iconRetinaUrl: '/assets/images/leaflet/marker-icon-2x.png',
    iconUrl: '/assets/images/leaflet/marker-icon.png',
    shadowUrl: '/assets/images/leaflet/marker-shadow.png',
  });

  export let locations: { lat: number; lng: number; title: string }[] = [];

  let mapContainer: HTMLElement;
  let map: L.Map;
  let resizeObserver: ResizeObserver;

  onMount(() => {
    if (!mapContainer) return;

    // Use default values if none provided from props
    const finalLocations = locations && locations.length > 0 
      ? locations 
      : [
          { lat: 43.81233, lng: 5.74987, title: "Mairie de Pierrevert" },
          { lat: 43.865545, lng: 5.597243, title: "Domaine de la Barbeirasse" }
        ];

    // Calculate center or fit bounds
    const bounds = L.latLngBounds(finalLocations.map(l => [l.lat, l.lng]));
    
    map = L.map(mapContainer);

    // Apply view/bounds BEFORE adding layers
    if (finalLocations.length > 0) {
        map.fitBounds(bounds, { padding: [50, 50] });
    } else {
        map.setView([43.845, 5.69], 11);
    }
    
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
    }).addTo(map);

    finalLocations.forEach(loc => {
      L.marker([loc.lat, loc.lng])
        .addTo(map)
        .bindPopup(loc.title);
    });

    // Better way to handle size changes/initial display
    resizeObserver = new ResizeObserver(() => {
      map.invalidateSize();
    });
    resizeObserver.observe(mapContainer);
  });

  onDestroy(() => {
    if (resizeObserver) {
      resizeObserver.disconnect();
    }
    if (map) {
      map.remove();
    }
  });
</script>

<div class="map-container" bind:this={mapContainer}></div>

<style lang="scss">
  .map-container {
    width: 100%;
    height: 300px;
    z-index: 1;
    border-radius: 4px;

    /* CSS FIX: Prevent global image styles from breaking Leaflet tiles */
    :global(img) {
      max-width: none !important;
      max-height: none !important;
      box-shadow: none !important;
      border: none !important;
    }
  }
</style>
